(() => {
  const pending = new Set();
  let frame;

  function sync(product) {
    const colours = new Map();
    product.querySelectorAll('variant-selects [data-islander-colour-option="true"] label[data-islander-new-colour="true"]').forEach((label) => {
      const value = label.control?.value || label.previousElementSibling?.value;
      const marker = label.querySelector('.islander-new-badge');
      if (value && marker) colours.set(value, marker.textContent.trim());
    });

    product.querySelectorAll('.globo-swatch-product-detail .g-variant-color-detail .select-option[data-value]').forEach((option) => {
      const label = option.querySelector('label');
      if (!label) return;
      const text = colours.get(option.dataset.value);
      let marker = label.querySelector('.islander-new-badge');
      if (!text) {
        label.removeAttribute('data-islander-new-colour');
        marker?.remove();
        return;
      }
      label.setAttribute('data-islander-new-colour', 'true');
      if (!marker) {
        marker = document.createElement('span');
        marker.className = 'islander-new-badge islander-new-badge--swatch';
        label.append(marker);
      }
      if (marker.textContent !== text) marker.textContent = text;
    });
  }

  function queue(node) {
    if (!(node instanceof Element)) return;
    const owner = node.closest('product-info');
    if (owner) pending.add(owner);
    node.querySelectorAll('product-info').forEach((product) => pending.add(product));
    if (!pending.size || frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      pending.forEach((product) => { if (product.isConnected) sync(product); });
      pending.clear();
    });
  }

  queue(document.documentElement);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.target instanceof Element && record.target.closest('.islander-new-badge')) return;
      queue(record.target);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => queue(event.target));
})();
